import React, { useState } from 'react';
import { faqs } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b-2 border-slate-200">
      <button 
        className="w-full py-6 flex justify-between items-center text-left focus:outline-none"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="font-bold text-lg text-ink-navy pr-8">{question}</span>
        <SafeIcon 
          name={isOpen ? "ChevronUp" : "ChevronDown"} 
          className="text-xl text-sky-500 flex-shrink-0" 
        />
      </button>
      {isOpen && (
        <div className="pb-6 text-slate-600 leading-relaxed pr-8">
          {answer}
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-extrabold text-ink-navy mb-4">Frequently Asked Questions</h1>
        <p className="text-lg text-slate-600">Got questions about shipping, returns, or our kits? We've got answers.</p>
      </div>

      <div className="bg-white rounded-2xl border-2 border-ink-navy p-6 md:p-10 shadow-[8px_8px_0_0_#1e1b4b]">
        <div className="mb-8 p-4 bg-sky-light/50 rounded-xl border border-sky-200 flex items-start gap-3">
          <SafeIcon name="Info" className="text-sky-600 text-xl mt-0.5" />
          <p className="text-sm text-slate-700">
            <strong>Customer Support Hours:</strong> Monday - Friday, 9am - 5pm EST. 
            For urgent inquiries regarding an order, please email support@littlelabstem.example.com.
          </p>
        </div>

        <div className="divide-y-0">
          {faqs.map((faq, idx) => (
            <FAQItem key={idx} question={faq.question} answer={faq.answer} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;